import { TranslatedText } from "@/components/common/text";

// One line per failed check, so a company failing both name and MC sees both reasons.
const failureReasons = ({ dotNumber, mcNumber, fmcsaVerification }) => {
    if (fmcsaVerification.status === "NOT_FOUND") return [`No FMCSA record found for DOT-${dotNumber}.`];
    if (fmcsaVerification.status !== "MISMATCH") return [];
    return [
        fmcsaVerification.mcMatch === false && `No active authority found for MC-${mcNumber ?? ""} in FMCSA records.`,
        fmcsaVerification.nameMatch === false && `Company name does not match the FMCSA record for DOT-${dotNumber}.`,
    ].filter(Boolean);
};

export const CompanyVerificationNotice = ({ company }) => {
    const reasons = failureReasons(company);
    if (reasons.length === 0) return null;

    return (
        <div className="flex w-full flex-col gap-1 rounded-lg bg-cm-p-container-red px-4 py-3 text-xs">
            {reasons.map((reason) => (
                <p key={reason} className="text-cm-p-on-container-red">
                    <TranslatedText>{reason}</TranslatedText>
                </p>
            ))}
            <p className="text-cm-p-text-secondary">
                <TranslatedText>Until resolved, access to Book Loads and Bid on Loads features is restricted.</TranslatedText>
            </p>
        </div>
    );
};
